import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import bubbleUpEvents from '../../utilities/bubble-up-events';
import unpick from '../../../utilities/unpick';
import reformatValue from '../../utilities/reformat-value';

function reformatZip(e, replacePattern) {
  if (replacePattern) {
    reformatValue(e, replacePattern.regExpString, replacePattern.newSubStr);
  } else {
    e.target.value = e.target.value.replace(/[^\d]/g, '').substring(0, 5);
  }
}

export default function ZipComponent(props) {
  const { onChange, isValid, replacePattern, innerRef } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'replacePattern', 'innerRef']);

  const eventProps = {
    onChange(e) {
      bubbleUpEvents(e, [reformatZip(e, replacePattern), onChange]);
    },
  };

  return (
    <InputMask
      {...p}
      {...eventProps}
      type="tel"
      aria-label={props.ariaLabel || 'Zip Code'}
      aria-placeholder={props.placeholder || ''}
      aria-invalid={!isValid}
      inputMode="text"
      ref={innerRef}
    />
  );
}

Component.propTypes = {
  onChange: PropTypes.func,
};

Component.defaultProps = {
  onChange: undefined,
};
